import React from "react";
import { CloseButton } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import Api from "services/api";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";

const CotationPopup = ({ open, onClose, callViewApi, transId }) => {
  const [reviseQuoteData, setReviseQuoteData] = useState(null);
  const [loader, setLoader] = useState(false);
  const { control, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      docs: [],
    },
  });

  useEffect(() => {
  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto"; // cleanup on unmount
  };
}, [open]);


  //   Fetch Revise Quotes here
  useEffect(() => {
    if (open && transId) {
      (async () => {
        try {
          const response = await Api.fetchReviseQuote(transId);
          const data = response?.data?.data || null;
          setReviseQuoteData(data);
          let costTable = [];
          if (data && data.cost_table) {
            try {
              costTable = JSON.parse(data.cost_table);
            } catch (e) {
              costTable = [];
            }
          }
          console.log("costTable", costTable);
          reset({
            docs: costTable.map((doc) => ({
              name: `${doc.file_name} / ${doc.target_language}`,
              wordCount: doc.word_count,
              rate: doc.rate,
              formatting: doc.formatting,
              amount: doc.total,
              target_language: doc.target_language,
            })),
            notes: data?.notes ?? "",
          });
        } catch (error) {
          console.error("Failed to fetch revise quote:", error);
          setReviseQuoteData(null);
          reset({ docs: [] });
        }
      })();
    }
  }, [open, reset]);

  if (!open) return null;

  const docs = watch("docs");

  // Calculate amount for each row
  const calculateAmount = (doc) => {
    return Number(doc.wordCount) * Number(doc.rate) + Number(doc.formatting);
  };

  //   Update Revise Quote Table here
  const onUpdate = (data) => {
    setLoader(true);
    const mappedDocs = data.docs.map((doc) => {
      const word_count = Number(doc.wordCount);
      const rate = Number(doc.rate);
      const formatting = Number(doc.formatting);
      const sub_total = word_count * rate;
      const total = sub_total + formatting;
      return {
        rate,
        sub_total,
        total,
        file_name: doc.name.split(" / ")[0],
        formatting,
        word_count,
        target_language: doc.target_language,
      };
    });

    const payload = {
      cost_table: mappedDocs,
      notes: data.notes || "",
      totalAmount: mappedDocs.reduce((sum, doc) => sum + doc.total, 0),
    };

    Api.updateReviseQuote(transId, payload)
      .then((response) => {
        console.log("Update response:", response?.data);
        toast.success(response?.data?.message, {
          className: "successToast",
        });

        callViewApi();
        setLoader(false);
        onClose();
      })
      .catch((error) => {
        console.error("Failed to update revise quote:", error);
        toast.error(error?.message, {
          className: "successToast",
        });
        setLoader(false);
      });
  };

  return (
    <div
    style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20, // so the modal doesn't touch edges on small screens
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          minWidth: 500,
          maxWidth: 900,
          width: "100%",
          maxHeight: "100%",
          padding: 32,
          boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
          position: "relative",
          overflowY: "auto", // ✅ scrollable if content overflows
        }}
      >
        <button
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "none",
            border: "none",
            fontSize: 22,
            cursor: "pointer",
          }}
          onClick={onClose}
          aria-label="Close"
        >
          <CloseButton style={{ width: 10, height: 10 }} />
        </button>
        <h2 style={{ marginBottom: 24 }}>Revise Quote</h2>
        {docs && docs.length > 0 ? (
          <form onSubmit={handleSubmit(onUpdate)}>
            {/* Notes field below the table */}
            <div style={{ margin: "16px 0" }}>
              <label
                htmlFor="notes"
                style={{
                  fontWeight: 500,
                  marginBottom: 8,
                  display: "block",
                  textAlign: "left",
                }}
              >
                Notes
              </label>
              <Controller
                name="notes"
                control={control}
                render={({ field }) => (
                  <input
                    id="notes"
                    style={{
                      width: "100%",
                      borderRadius: 8,
                      border: "1px solid #e3e6ea",
                      padding: "12px 12px",
                      fontSize: 16,
                      color: "#222",
                      background: "#f8f9fa",
                      resize: "vertical",
                    }}
                    placeholder="Enter notes here..."
                    {...field}
                  />
                )}
              />
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: 16,
              }}
            >
              <thead>
                <tr style={{ background: "#222", color: "#fff" }}>
                  <th style={{ padding: "10px 8px", textAlign: "left" }}>
                    Document Name
                  </th>
                  <th style={{ padding: "10px 8px", textAlign: "left" }}>
                    Total Word Count
                  </th>
                  <th style={{ padding: "10px 8px", textAlign: "left" }}>
                    Rate by Lang
                  </th>
                  <th style={{ padding: "10px 8px", textAlign: "left" }}>
                    Formatting
                  </th>
                  <th style={{ padding: "10px 8px", textAlign: "left" }}>
                    Total Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {docs.map((doc, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: "8px" }}>{doc.name}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <Controller
                        name={`docs.${idx}.wordCount`}
                        control={control}
                        render={({ field }) => (
                          <input
                            type="number"
                            min={0}
                            style={{
                              width: 120,
                              height: 40,
                              borderRadius: 12,
                              background: "#f8f9fa",
                              border: "1px solid #e3e6ea",
                              padding: "0 16px",
                              fontSize: 16,
                              color: "#bfc7d1",
                              outline: "none",
                            }}
                            placeholder="Total Word Count"
                            {...field}
                          />
                        )}
                      />
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <Controller
                        name={`docs.${idx}.rate`}
                        control={control}
                        render={({ field }) => (
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            style={{
                              width: 120,
                              height: 40,
                              borderRadius: 12,
                              background: "#f8f9fa",
                              border: "1px solid #e3e6ea",
                              padding: "0 16px",
                              fontSize: 16,
                              color: "#bfc7d1",
                              outline: "none",
                            }}
                            placeholder="Rate by Lang"
                            {...field}
                          />
                        )}
                      />
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      <Controller
                        name={`docs.${idx}.formatting`}
                        control={control}
                        render={({ field }) => (
                          <input
                            type="number"
                            min={0}
                            step={0.01}
                            style={{
                              width: 120,
                              height: 40,
                              borderRadius: 12,
                              background: "#f8f9fa",
                              border: "1px solid #e3e6ea",
                              padding: "0 16px",
                              fontSize: 16,
                              color: "#bfc7d1",
                              outline: "none",
                            }}
                            placeholder="Formatting"
                            {...field}
                          />
                        )}
                      />
                    </td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      ${calculateAmount(doc).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ textAlign: "right" }}>
              {/* Total row above Update button */}
              <div
                style={{
                  background: "#222",
                  color: "#fff",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: 48,
                  marginTop: 0,
                  borderRadius: 6,
                  fontSize: 18,
                  marginBottom: 12,
                }}
              >
                <div style={{ paddingLeft: 16 }}>Total</div>
                <div
                  style={{ width: 120, textAlign: "right", paddingRight: 16 }}
                >
                  $
                  {docs
                    .reduce((sum, doc) => sum + calculateAmount(doc), 0)
                    .toFixed(2)}
                </div>
              </div>

              <SubmitButton
                btnText="Update & Resend to Client"
                buttonType="submit"
                loader={loader}
              />
            </div>
          </form>
        ) : (
          <div
            style={{ textAlign: "center", padding: "32px 0", color: "#888" }}
          >
            No data available.
          </div>
        )}
      </div>
    </div>
  );
};

export default CotationPopup;
